import React, {useEffect, useState} from 'react'
import arrowCurve from '../assets/images/arrow-curve.svg'
import plate from '../assets/images/td-plate.svg'
import cocukplate from '../assets/images/td-plate-cocuk.png'
import images from 'assets/images/images'
import {useRequest} from 'hooks/useRequest'
import auth from 'utils/Auth'
import ApprovalModal from 'components/approvalModal/ApprovalModal'
import {authModalOpen, getAllBasketFunc} from 'redux/features/general/generalSlice'
import {toast} from 'react-toastify'
import {useDispatch} from 'react-redux'
import LoaderTwo from './LoaderTwo'
import useTranslate from 'hooks/useTranslate'
import {Trans} from 'react-i18next'
import {useSelector} from 'react-redux'
import Drawer from 'react-modern-drawer'
import AddBasketDrawerStageOne from 'components/home/drawers/AddBasketDrawerStageOne'
import AddBasketDrawerStageTwo from 'components/home/drawers/AddBasketDrawerStageTwo'
import {Helmet} from 'react-helmet'
import Breadcrumbs from 'components/Breadcrumbs'
import useQuery from 'hooks/useQuery'
import Dropdown from 'components/dropdown/Dropdown'
import {dataLayerPush} from 'utils/Datalayer'
const CreatePlate = () => {
    const {t} = useTranslate()
    const { general } = useSelector(state => state)
    const { getAllBasket } = general
	let query = useQuery();
    const [totalPrice,setTotalPrice] = useState(0)
    const [request, loadingRequest] = useRequest()
    const [productList,setProductList] = useState([])
    const [selectedProduct, setSelectedProduct] = useState()
    const [productStage, setProductStage] = useState(1)
    const [productCount, setProductCount] = useState(1)
    const [isOpenDrawer, setIsOpenDrawer] = useState(false)
    const [singleDrawerProduct, setSingleDrawerProduct] = useState({ id: null, item: null }) //redux kullanmadım.Baska bi yerde lazım degil cünkü.Bilginize...
    const [approvalModal, setApprovalModal] = useState({open:false,order:null,type:null})
    const dispatch = useDispatch()
    const [imageLoading, setImageLoading] = useState(true)
    const defaultSelectedByQuery = query.get('product')
    useEffect(() => {
        request('/Catalog/Products/CreateYourOwnPlate',{
            method:'GET',
            headers:{
                RestaurantId : auth?.getUserChoises()?.restaurantId,
                DeliveryType : auth?.getUserChoises()?.deliveryType,
                NeighbourhoodId : auth?.getUserChoises()?.neighbourhoodId,
                RegionId : auth?.getUserChoises()?.regionId,
            }
        }).then(res => {
            if (res.data.result) {
                setProductList(res.data.result.map(p => ({...p, attributes: p.attributes.map(a => ({...a, values:a.values.map(v => ({...v,isPreSelected:false}))}))})))
            }
        })
    },[])
    useEffect(() => {
        if (defaultSelectedByQuery, productList.length > 0) {
            setSelectedProduct(productList.find(p => p.url == defaultSelectedByQuery))
        }
    },[defaultSelectedByQuery, productList])
    useEffect(() => {
        if (!isOpenDrawer) {
            setSingleDrawerProduct({ id: null, item: null })
            setSelectedProduct()
        }
    },[ isOpenDrawer])
    useEffect(() => {
        if (selectedProduct) {
            const secondSelect = selectedProduct?.attributes?.find(a => a.controlType == 6)?.values?.find(v => v.isPreSelected)
            if (secondSelect) {
                setTotalPrice(Number(selectedProduct?.discountedPrice) +Number(secondSelect?.price) )
            
            } else {
                setTotalPrice(selectedProduct?.discountedPrice)
            }
        }
    },[selectedProduct])
    const handleChange = (e) => {
        setSelectedProduct(e)
    }
    const handleChangeMenuItems = (e) => {
        const selectedMenuItem = e
        setSelectedProduct({...selectedProduct,attributes: selectedProduct?.attributes?.map(att => {
            if (att.controlType == 6) {
                return {...att, values: att?.values.map(v => {
                    if(v.id == selectedMenuItem.id){
                        return {...v, isPreSelected:true}
                    } else {
                        return {...v, isPreSelected:false}
                    }
                })}
            } else {
                return att
            }
        })})
    }
    console.log(selectedProduct,'selectedProduct')
    const handleDrawer = () => {
        const secondSelect = selectedProduct?.attributes?.find(a => a.controlType == 6)?.values?.find(v => v.isPreSelected)
        if (!auth.isHaveToken()) {
                if (selectedProduct) {
                    dataLayerPush({
                        event:"kendi_tabagini_olustur_s2",
                        secim_1: selectedProduct?.name,
                        secim_2: selectedProduct?.attributes?.find(a => a.controlType == 6)?.values?.find(v => v.isPreSelected )?.name,
                        menu_type:selectedProduct?.isChildMenu? 'Çocuk':'Yetişkin',
                        login_status:auth.isHaveToken() ? true : false
                        })
                    return dispatch(authModalOpen({open:true,returnUrl:`/kendi-tabagini-olustur?product=${selectedProduct?.url}`}))
                } else {
                    return toast.error(t('selectAProduct'))
                }
            }
        if (secondSelect) {
            setIsOpenDrawer(true)
                dataLayerPush({
                event:"kendi_tabagini_olustur_s2",
                secim_1: selectedProduct?.name,
                secim_2: selectedProduct?.attributes?.find(a => a.controlType == 6)?.values?.find(v => v.isPreSelected )?.name,
                menu_type:selectedProduct?.isChildMenu? 'Çocuk':'Yetişkin',
                login_status:auth.isHaveToken() ? true : false
                })
            setSingleDrawerProduct({
                id:selectedProduct.id,
                createdPlate:{
                    ...selectedProduct,
                    attributes: selectedProduct.attributes.map(a => {
                        if (a.controlType == 6) {
                            return {...a, controlType: 1}
                        } else {
                            return a
                        }
                    })
                }
            })
        }
        else {
            toast.error(t('fillAllSelections'))
        }
    }
    const clearBasket = () => {
        if (approvalModal.type == 'DELETE') {
          request(`/ShoppingCart/RemoveItem?id=${approvalModal.order.id}`, {
            method: 'POST',
            //data: {id : id},
            headers: {
              restaurantId: auth.getUserChoises()?.restaurantId,
              deliveryType: auth.getUserChoises()?.deliveryType,
              neighbourhoodId: auth.getUserChoises()?.neighbourhoodId,
              regionId: auth.getUserChoises()?.regionId,
        
            }
          }).then((res) => {
            if(res.data){
              dispatch(getAllBasketFunc(res?.data?.result))
              toast.success(t('successfullToast',{type:t('delete'),name:''}))
              setApprovalModal({open:false,order:null,type:null})
            setProductStage(2)
            }
        })
        } else {
          request('/ShoppingCart/ClearCart', {
            method: 'POST',
            headers: {
              restaurantId: auth.getUserChoises()?.restaurantId,
              deliveryType: auth.getUserChoises()?.deliveryType,
              neighbourhoodId: auth.getUserChoises()?.neighbourhoodId,
              regionId: auth.getUserChoises()?.regionId,
            }
          }).then((res) => {
            if(res){
              dispatch(getAllBasketFunc([]))
                setProductStage(2)
                setApprovalModal({open:false,order:null,type:null})
            }
          })
        }
        
      }
    if (loadingRequest) {
        return <LoaderTwo isDataLoading={loadingRequest} />
    }
 
  return <div className='create-plate'>
        <Helmet>
            <title>{t('createYourOwnPlateOnlyText')}</title>
        </Helmet>
       
        <div className={imageLoading ? 'home-slider' :'plate-container'}>
        <Breadcrumbs
            className={'breadcrumbs w-100 bg-transparent mb-3'}
            breadcrumbList={[
                {text:t('homePage'), link:'/'},
                {text:t('createYourOwnPlateOnlyText').toLocaleUpperCase(), link:'/'},
            ]} 
        />
            {
                imageLoading && <div className="skeleton-home-slider">
                <div className="skeleton"/>
            </div>
            }
            <div className={imageLoading ? 'd-none' : 'plate-container-top'}>
                <h1 className="plate-container-top-title">
                    <Trans 
                        i18nKey={selectedProduct?.isChildMenu ? 'createYourOwnPlateChild':'createYourOwnPlate'}
                        components={{ redText:  <span className="plate-container-top-title-dark"/> }}
                    />
                </h1>
                <div className="plate-container-top-btn">
                    <div className="btn-primary btn-s" onClick={() => handleDrawer()}>
                        {t('askTheChef')}
                        <img src={images.plus2} alt=""/>
                    </div>
                </div>
            </div>
            <div className={imageLoading ? 'd-none':'plate-container-body'}>
                <div className={`plate-container-body-plate ${selectedProduct?.isChildMenu ? 'child':''}`}>
                    {
                        selectedProduct?.isChildMenu ? <img onLoad={() =>  setImageLoading(false)} src={cocukplate} alt="" className="plate-container-body-plate"/> :  <img onLoad={() =>  setImageLoading(false)} src={plate} alt="" className="plate-container-body-plate"/>
                    }
                </div>
                <div className={`plate-container-body-dropdowns ${selectedProduct?.isChildMenu ? 'child':''}`}>
                    <div className={`plate-container-body-dropdowns-left`}>
                        <div className={`plate-container-body-dropdowns-left-mobile-img`}>
                            {selectedProduct && <img src={selectedProduct?.picture} alt={selectedProduct?.name}/>}
                        </div>
                    </div>
                    <div className={`plate-container-body-dropdowns-mid`}>
                        <div className={`plate-container-body-dropdowns-mid-mobile-img`}>
                            {selectedProduct?.attributes?.find(a => a.controlType == 6)?.values?.find(v => v.isPreSelected ) && <img src={selectedProduct?.attributes?.find(a => a.controlType == 6)?.values?.find(v => v.isPreSelected )?.picture} alt={selectedProduct?.attributes?.find(a => a.controlType == 6)?.values?.find(v => v.isPreSelected )?.name}/>}
                        </div>
                    </div>
                </div>
               
                <div className="plate-container-body-text-right">
                    <div className="plate-container-body-text-right-img">
                        <img src={arrowCurve} alt=""/>
                    </div>
                    <div className="d-flex flex-column gap-2">
                        <div className="header-l text-primary">
                            {t('whenReady')}
                        </div>
                        <div className="header-l text-orange">
                            {totalPrice && totalPrice} TL
                        </div>
                    </div>
                </div>
                <div className="plate-container-body-text-left">
                    <div className="header-l text-primary">
                        {selectedProduct?.isChildMenu ? t('typeChickenChild') :t('typeChicken',{typeNumber:20})}
                    </div>
                    <div className="plate-container-body-text-left-img">
                        <img src={arrowCurve} alt=""/>
                    </div>
                </div>
                <div className="plate-container-body-text-bottom">
                    <div className="plate-container-body-text-bottom-img">
                        <img src={arrowCurve} alt=""/>
                    </div>
                    <div className="header-l text-primary text-center">
                    <Trans 
                        i18nKey={'saladOrVegetable'}
                        components={{ break: <br/> }}
                    />
                    </div>
                </div>
                <div className={`plate-container-body-text-bottom-2 ${selectedProduct?.isChildMenu ? 'child' : ''}`}>
                    <div className="plate-container-body-text-bottom-img">
                        <img src={arrowCurve} alt=""/>
                    </div>
                    <div className="header-l text-primary text-center">
                    <Trans 
                        i18nKey={'saladOrVegetableChild'}
                        components={{ break: <br/> }}
                    />
                    </div>
                </div>
            </div>
            <div className={imageLoading ? 'd-none': 'plate-container-body-mobile'}>
                <div className="row" style={{marginTop:'136px'}}>
                    <div className="col-md-6">
                        <div className="form-control">
                            <Dropdown
                                dropdownList={productList}
                                onSelect={(item) => handleChange(item)}
                                placeholder={t('choose')}
                                value={selectedProduct}
                            />
                        </div>
                    </div>
                    <div className="col-md-6">
                        <div className="form-control">
                            <Dropdown
                                dropdownList={selectedProduct?.attributes?.find(a => a.controlType == 6)?.values}
                                onSelect={(item) => handleChangeMenuItems(item)}
                                disabled={!selectedProduct}
                                placeholder={selectedProduct ? t('choose') : t('chooseFirstMenu')}
                                value={selectedProduct?.attributes?.find(a => a.controlType == 6)?.values?.find(v => v.isPreSelected )}

                            />
                        </div>
                    </div>
                </div>
                <div onClick={() => handleDrawer()} className="plate-container-body-mobile-btn btn-primary btn-s">{t('askTheChef').toUpperCase()}</div>
            </div>
        </div>
      <ApprovalModal onClose={approvalModal.open} title={approvalModal.type == 'DELETE' ? t('youRemoveOrderFromList') : t('youCancelOrder')} desc={approvalModal.type == 'DELETE' ? t('sureYouWantRemoveFromListOrder') : t('sureYouWantCancelOrder')} closeModal={() => setApprovalModal({open:false,order:null,type:null})} onApproval={clearBasket} />
      <Drawer
        open={isOpenDrawer}
        onClose={() => setIsOpenDrawer(!isOpenDrawer)}
        direction='right'
        className='homeAddBasketDrawer'
    >
        {productStage == 1 && <AddBasketDrawerStageOne setSingleDrawerProduct={setSingleDrawerProduct} isOpenDrawer={isOpenDrawer} setProductCount={setProductCount} productCount={productCount} productData={singleDrawerProduct} setIsOpenDrawer={setIsOpenDrawer} setProductStage={setProductStage} />}
        {productStage == 2 && <AddBasketDrawerStageTwo setApprovalModal={setApprovalModal} setSingleDrawerProduct={setSingleDrawerProduct} isOpenDrawer={isOpenDrawer} getAllBasket={getAllBasket} setProductCount={setProductCount} productCount={productCount} setIsOpenDrawer={setIsOpenDrawer} setProductStage={setProductStage} />}
    </Drawer>
    </div>
}

export default CreatePlate